import * as requests from "../../coraWebComponents/utils/requests";
import { strToDate } from '../../coraWebComponents/utils/convert';
import urls from "../../constants/Urls";

const buildZmluvy = (id = "") => {
  return `${urls.Zmluvy}/${id}`;
};

export const getZmluva = async (id) => {
  if (id === 0) {
    return null;
  }

  const url = buildZmluvy(id);
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getListZmluva = async (filter, sort, page) => {
  const url = buildZmluvy();

  try {
    let res = await requests.getList(url, filter, sort, page);
    res.Data.Items.forEach((item) => {
      item.D_UCINNOSTI = strToDate(item.D_UCINNOSTI);
      item.D_UKONCENIA = strToDate(item.D_UKONCENIA);
      item.D_VYHOTOVENIA = strToDate(item.D_VYHOTOVENIA);
    });
    return res;
  } catch (error) {
    throw error;
  }
};
